(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-soft-opening"]) return;
  try {
    
  if (!customElements.get('pp-soft-opening')) {
    customElements.define('pp-soft-opening', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const details = this.querySelector('[data-soft-open-details]');
        const enter = this.querySelector('[data-soft-open-enter]');
        if (!dialog || !details || !enter || typeof dialog.showModal !== 'function') return;
        const key = 'pp-soft-opening-seen-v1';
        let previousOverflow = '';
        const open = () => {
          if (dialog.open) return;
          previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          dialog.showModal();
        };
        const dismiss = () => dialog.close();
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = previousOverflow;
          try { sessionStorage.setItem(key, 'true'); } catch {}
        });
        details.hidden = false;
        details.addEventListener('click', open);
        enter.addEventListener('click', dismiss);
        let seen = false;
        try { seen = sessionStorage.getItem(key) === 'true'; } catch {}
        if (this.dataset.autoOpen === 'true' && !seen) open();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
